import CollapsibleIcon from './CollapsibleIcon';

export default CollapsibleIcon;
